import { useEffect, useRef } from 'react'

export const motionSafe = () => !window.matchMedia('(prefers-reduced-motion: reduce)').matches

export function useReveal() {
  const ref = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (!ref.current) return
    const nodes = ref.current.querySelectorAll<HTMLElement>('[data-reveal]')
    if (!motionSafe()) { nodes.forEach((node) => node.classList.add('revealed')); return }
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => { if (entry.isIntersecting) { entry.target.classList.add('revealed'); observer.unobserve(entry.target) } }), { threshold: .12, rootMargin: '0px 0px -5% 0px' })
    nodes.forEach((node) => observer.observe(node)); return () => observer.disconnect()
  }, [])
  return ref
}

export function useCountUp(value: string) {
  const ref = useRef<HTMLSpanElement>(null)
  useEffect(() => {
    const node = ref.current, target = parseInt(value, 10); if (!node || Number.isNaN(target)) return
    const suffix = value.replace(String(target), '')
    if (!motionSafe()) { node.textContent = value; return }
    const observer = new IntersectionObserver(([entry]) => { if (!entry.isIntersecting) return; const start = performance.now(); const draw = (now: number) => { const progress = Math.min(1, (now - start) / 1100); node.textContent = `${Math.round(target * (1 - Math.pow(1 - progress, 3)))}${suffix}`; if (progress < 1) requestAnimationFrame(draw) }; requestAnimationFrame(draw); observer.disconnect() })
    observer.observe(node); return () => observer.disconnect()
  }, [value])
  return ref
}
